"use client"

import { useState, useEffect } from "react"
import { baseUrl } from "../../config/baseUrl"

const ReferralList = () => {
    const [referrals, setReferrals] = useState([])
    const [loading, setLoading] = useState(true)
    const [error, setError] = useState(null)
    const [currentPage, setCurrentPage] = useState(1)
    const [itemsPerPage] = useState(10)

    const [filters, setFilters] = useState({
        startDate: "",
        endDate: "",
        status: "",
        type: "",
    })

    const userDetails = JSON.parse(localStorage.getItem("user"))

    useEffect(() => {
        fetchReferrals()
    }, [currentPage, filters])

    const fetchReferrals = async () => {
        try {
            setLoading(true)

            const queryParams = new URLSearchParams()

            if (filters.status) queryParams.append("status", filters.status)
            if (filters.type) queryParams.append("type", filters.type)
            if (filters.startDate) queryParams.append("startDate", filters.startDate)
            if (filters.endDate) queryParams.append("endDate", filters.endDate)

            const response = await fetch(
                `${baseUrl}/owner/referral/referral-list/${userDetails?._id}?${queryParams.toString()}`
            )

            if (!response.ok) {
                throw new Error("Failed to fetch referrals")
            }

            const data = await response.json()
            setReferrals(data.data || [])
        } catch (err) {
            setError(err.message)
        } finally {
            setLoading(false)
        }
    }

    const handleFilterChange = (filterName, value) => {
        setFilters((prev) => ({
            ...prev,
            [filterName]: value,
        }))
        setCurrentPage(1)
    }

    const clearFilters = () => {
        setFilters({
            startDate: "",
            endDate: "",
            status: "",
            type: "",
        })
        setCurrentPage(1)
    }

    const getStatusBadge = (status) => {
        const statusClasses = {
            applied: "badge bg-warning",
            confirmed: "badge bg-success",
            pending: "badge bg-info",
        }
        return statusClasses[status?.toLowerCase()] || "badge bg-secondary"
    }

    const formatDate = (dateString) => {
        if (!dateString) return "N/A"
        const date = new Date(dateString)
        return date.toLocaleDateString("en-IN", {
            day: "2-digit",
            month: "short",
            year: "numeric",
        })
    }

    const formatTime = (dateString) => {
        if (!dateString) return ""
        const date = new Date(dateString)
        return date.toLocaleTimeString("en-IN", {
            hour: "2-digit",
            minute: "2-digit",
            hour12: true,
        })
    }

    // Pagination
    const indexOfLastItem = currentPage * itemsPerPage
    const indexOfFirstItem = indexOfLastItem - itemsPerPage
    const currentReferrals = referrals.slice(indexOfFirstItem, indexOfLastItem)
    const totalPages = Math.ceil(referrals.length / itemsPerPage)

    // if (loading) {
    //     return (
    //         <div className="container-fluid">
    //             <div className="d-flex justify-content-center align-items-center" style={{ height: "400px" }}>
    //                 <div className="spinner-border text-primary" role="status" />
    //             </div>
    //         </div>
    //     )
    // }

    if (error) {
        return (
            <div className="container-fluid">
                <div className="alert alert-danger">
                    Error loading referrals: {error}
                </div>
            </div>
        )
    }

    return (
        <div className="main-sec">
            <div className="container-fluid">
                <div className="card shadow-sm">
                    <div className="card-header bg-white border-bottom">
                        <h5 className="mb-0">
                            <i className="fas fa-users me-2 text-primary"></i>
                            Referral List
                        </h5>
                    </div>

                    <div className="card-body">
                        {/* Filters */}
                        <div className="row mb-4">
                            <div className="col-md-2">
                                <label className="form-label small fw-semibold">Status</label>
                                <select
                                    className="form-select form-select-sm"
                                    value={filters.status}
                                    onChange={(e) => handleFilterChange("status", e.target.value)}
                                >
                                    <option value="">All Status</option>
                                    <option value="APPLIED">Applied</option>
                                    <option value="CONFIRMED">Confirmed</option>
                                    <option value="PENDING">Pending</option>
                                </select>
                            </div>

                            <div className="col-md-2">
                                <label className="form-label small fw-semibold">Category</label>
                                <select
                                    className="form-select form-select-sm"
                                    value={filters.type}
                                    onChange={(e) => handleFilterChange("type", e.target.value)}
                                >
                                    <option value="">All Categories</option>
                                    <option value="package">Mock Test</option>
                                    <option value="ebook">E Book</option>

                                </select>
                            </div>

                            <div className="col-md-2">
                                <label className="form-label small fw-semibold">Start Date</label>
                                <input
                                    type="date"
                                    className="form-control form-control-sm"
                                    value={filters.startDate}
                                    onChange={(e) => handleFilterChange("startDate", e.target.value)}
                                />
                            </div>

                            <div className="col-md-2">
                                <label className="form-label small fw-semibold">End Date</label>
                                <input
                                    type="date"
                                    className="form-control form-control-sm"
                                    value={filters.endDate}
                                    onChange={(e) => handleFilterChange("endDate", e.target.value)}
                                />
                            </div>
                        </div>

                        {/* Table */}
                        <div className="table-responsive">
                            <table className="table table-hover align-middle">
                                <thead className="table-primary">
                                    <tr>
                                        <th>SN</th>
                                        <th>Referrer</th>
                                        <th>Package</th>
                                        <th>Commission</th>
                                        <th>Date</th>
                                        <th>Status</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {loading ? (
                                        <tr>
                                            <td colSpan="6" className="text-center py-4">
                                                <div className="spinner-border text-primary" role="status" />
                                            </td>
                                        </tr>
                                    ) : currentReferrals.length ? (
                                        currentReferrals.map((ref, index) => (
                                            <tr key={ref._id}>
                                                <td>{indexOfFirstItem + index + 1}</td>
                                                <td>{ref.referrerUserId?.name || "N/A"}</td>
                                                <td>{ref.package_id?.title || "N/A"}</td>
                                                <td>{ref.commissionAmount}</td>
                                                <td>
                                                    {formatDate(ref.createdAt)}
                                                    <br />
                                                    <small className="text-muted">
                                                        {formatTime(ref.createdAt)}
                                                    </small>
                                                </td>
                                                <td>
                                                    <span className={getStatusBadge(ref.status)}>
                                                        {ref.status}
                                                    </span>
                                                </td>
                                            </tr>
                                        ))
                                    ) : (
                                        <tr>
                                            <td colSpan="6" className="text-center">
                                                No referrals found
                                            </td>
                                        </tr>
                                    )}
                                </tbody>

                            </table>
                        </div>

                        {/* Pagination */}
                        {totalPages > 1 && (
                            <nav>
                                <ul className="pagination pagination-sm justify-content-end">
                                    {[...Array(totalPages)].map((_, i) => (
                                        <li
                                            key={i}
                                            className={`page-item ${currentPage === i + 1 ? "active" : ""}`}
                                        >
                                            <button
                                                className="page-link"
                                                onClick={() => setCurrentPage(i + 1)}
                                            >
                                                {i + 1}
                                            </button>
                                        </li>
                                    ))}
                                </ul>
                            </nav>
                        )}
                    </div>
                </div>
            </div>

            <style>
                {`
                  .table thead tr th {
                    background: #26a084 !important;
                  }
                `}
            </style>
        </div>
    )
}

export default ReferralList
